import { c as _c } from "react/compiler-runtime";
import { Checkbox } from '@systemeio/ui';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { WEEKDAYS_LABELS, WeekdaysKeys } from './constants';
import { SelectedWeekDaysType } from './types';
export interface WeekdaysPickerProps extends Omit<React.HTMLProps<HTMLDivElement>, 'onChange'> {
  selectedWeekdays: SelectedWeekDaysType;
  onChange: (selectedWeekdays: SelectedWeekDaysType) => void;
}
function WeekdaysPicker(t0) {
  const $ = _c(14);
  let className;
  let onChange;
  let props;
  let selectedWeekdays;
  if ($[0] !== t0) {
    ({
      selectedWeekdays,
      onChange,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = onChange;
    $[3] = props;
    $[4] = selectedWeekdays;
  } else {
    className = $[1];
    onChange = $[2];
    props = $[3];
    selectedWeekdays = $[4];
  }
  const {
    t
  } = useLocoTranslation();
  const t1 = `flex flex-col justify-center gap-4 ${className}`;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = Object.entries(WeekdaysKeys);
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== onChange || $[7] !== selectedWeekdays || $[8] !== t) {
    t3 = t2.map(t4 => {
      const [, key] = t4;
      return <Checkbox key={key} label={t(WEEKDAYS_LABELS[key])} value={selectedWeekdays[key]} onChange={changedValue => onChange({
        ...selectedWeekdays,
        [key]: changedValue
      })} />;
    });
    $[6] = onChange;
    $[7] = selectedWeekdays;
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== props || $[11] !== t1 || $[12] !== t3) {
    t4 = <div className={t1} {...props}>{t3}</div>;
    $[10] = props;
    $[11] = t1;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
export default WeekdaysPicker;